import { createFileRoute } from '@tanstack/react-router'
import { adminRouteState } from '../features/admin/route-state'
import { projectTemplatesQuery } from '../features/projects/api'
import { ProjectTemplatesAdmin } from '../features/projects/templates-admin'

export const Route = createFileRoute('/admin/project-templates')({
  ...adminRouteState,
  loader: ({ context }) => context.queryClient.ensureQueryData(projectTemplatesQuery()),
  component: ProjectTemplatesAdmin,
})
